/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import axios from 'axios';
import Button from '../../ui/Button';
import BinaryRadioButton from '../ui/BinaryRadioButton';
import MultiFileUpload from '../ui/MultiFileUpload';
import { toolTipWrap, toolTip } from '../SharedFormStyles';
import { showNextButton, getNextLink } from '../FormStepperFunctions';
import withProperty from '../WithProperty';
import getBase64 from '../../FileUploads';
import ActionButton from '../../ui/ActionButton';
import colors from '../../../css/colors';
import CurrencyField from '../../ui/CurrencyField';
import { Checkbox, Icon } from 'semantic-ui-react';
import SaveAndHoldButton from '../SaveAndHoldButton';
import SubmitFormButton from '../SubmitFormButton';
import withUser from '../../../lib/WithUser';
import AssessToInput from '../AssessToInput';
import GoToProofingWorkspace from '../GoToProofingWorkspace';
import WithDocumentStation from '../ui/DocumentStation/WithDocumentStation';
import ReusableTopOfForm from '../ReusableTopOfForm';

const searchTypeId = 8;

const baseViolationInfo = 'CAMIS: \nDOCKET: \nVIOLATION DATE: ';

class HealthDepartmentViolation extends Component {
  state = {
    violationsFound: false,
    attachedFiles: [],
    additionalInfo: '',
    pdfHtml: '',
    loaderStatus: false,
    doNotCheck: false,
    owners: '',
    searchId: 0,
    ratActivityFound: false,
  };

  componentDidMount = async () => {
    axios
      .get(`/api/searches/GetSearchByType/${searchTypeId}/${+this.props.match.params.propertyid}`)
      .then(({ data }) => {
        this.props.setSearchId(data.id);
        this.setState({ searchId: data.id });
      });
    const { data: savedData } = await axios.get(
      `/api/searches/getSaved?propertyId=${+this.props.match.params.propertyid}&searchTypeId=${searchTypeId}`
    );

    if (savedData) {
      this.setState({ ...savedData });
    }
  };

  onFilesAdded = files => {
    this.setState({ attachedFiles: [...this.state.attachedFiles, ...files] });
  };

  onFileRemoved = file => {
    this.setState({
      attachedFiles: this.state.attachedFiles.filter(f => f !== file),
    });
  };

  handlePreview = async () => {
    const { data: html } = await axios.post('/api/searches/CreatePDF', {
      template: 'twofieldtemplate',
      data: await this.getFormContent(),
    });
    this.setState({ pdfHtml: html });
  };

  handleDownload = async () => {
    this.setState({ loaderStatus: true });
    await axios.post('/api/searches/DownloadPDF', {
      template: 'twofieldtemplate',
      data: await this.getFormContent(),
    });
    const nextLink = getNextLink(
      this.props.property.orderId,
      searchTypeId,
      this.props.match.params.propertyid
    );
    if (nextLink == null) {
      this.props.history.push(`/orders/order-information/${this.props.property.orderId}`);
    } else {
      this.props.history.push(nextLink);
    }
    this.setState({ loaderStatus: false });
  };

  getFormContent = async () => {
    const {
      violationsFound,
      additionalInfo,
      attachedFiles = {},
      doNotCheck,
      owners,
      ratActivityFound,
    } = this.state;
    const promises = attachedFiles.map(async f => {
      const base64 = await getBase64(f);
      return { name: f.name, base64String: base64 };
    });
    const files = await Promise.all(promises);
    return {
      date: new Date(),
      searchType: 'Health Department Violation',
      fieldOne: {
        selected: !violationsFound,
        text: `No record of existing Health Department ${
          this.props.property.municipalityType.toLowerCase() === 'borough' ? 'Window Guard ' : ''
        }Violations`,
      },
      fieldTwo: {
        selected: violationsFound,
        text: 'Violations found (see below).',
      },
      violationsFound,
      additionalInfo,
      doNotCheck,
      additionalInformation: additionalInfo,
      propertyId: +this.props.match.params.propertyid,
      searchTypeId,
      searchDocumentType: 'Municipal Attachment',
      attachments: files,
      owners,
      runDate: this.props.runDate,
      ratActivityFound,
    };
  };

  render() {
    const {
      violationsFound,
      additionalInfo,
      pdfHtml,
      loaderStatus,
      doNotCheck,
      owners,
      ratActivityFound,
    } = this.state;
    const showNext = showNextButton(this.props.property.orderId, searchTypeId);
    const params = new URLSearchParams(this.props.location.search);
    const isEdit = params.get('isEdit');
    return (
      <div css={{ display: 'flex', height: '100%' }}>
        <div css={{ width: '50%' }}>
          <div css={{ width: 654 }}>
            <ReusableTopOfForm
              handlePreview={this.handlePreview}
              searchHeader="Health Department Violation Search"
              propertyId={this.props.match.params.propertyid}
              searchTypeId={searchTypeId}
              property={this.props.property}
              isEditMode={this.props.match.params.isEditMode}
              getFormContent={this.getFormContent}
              template="twofieldtemplate"
              searchId={this.state.searchId}
            />
            <AssessToInput
              value={owners}
              onChange={e => this.setState({ owners: e.target.value })}
              propertyId={+this.props.match.params.propertyid}
            />

            <Checkbox
              checked={doNotCheck}
              label={'Do not check'}
              onChange={() => this.setState({ doNotCheck: !doNotCheck })}
            />
            {!doNotCheck && (
              <BinaryRadioButton
                headerText="Have health violations been found?"
                trueText="Yes"
                falseText="No"
                checkedState={violationsFound}
                onChange={checked => {
                  const currentViolationsFound = this.state.violationsFound;
                  this.setState({
                    violationsFound: checked,
                    additionalInfo:
                      currentViolationsFound === checked
                        ? additionalInfo
                        : checked
                        ? additionalInfo + baseViolationInfo + '\n\n'
                        : '',
                  });
                }}
              />
            )}
            {violationsFound && (
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ additionalInfo: additionalInfo + `${baseViolationInfo}\n\n` })}
              >
                <Icon name="plus" /> Add Violation
              </div>
            )}
            <BinaryRadioButton
              headerText="Rat activity found?"
              trueText="Yes"
              falseText="No"
              checkedState={ratActivityFound}
              onChange={checked => {
                const ratActivity = this.state.ratActivityFound;
                this.setState({
                  ratActivityFound: checked,
                  additionalInfo:
                    ratActivity === checked
                      ? additionalInfo
                      : checked
                      ? additionalInfo + 'Inspection - Rat Activity Found\n\n'
                      : additionalInfo.replace('Inspection - Rat Activity Found\n\n', ''),
                });
              }}
            />
            <div css={{ margin: '32px 0' }}>
              <textarea
                css={{
                  resize: 'none',
                  backgroundColor: colors.greyOrder,
                  borderRadius: 3,
                  width: 654,
                  height: 192,
                  marginBottom: 24,
                  ':focus': { outline: 0 },
                }}
                value={additionalInfo}
                onChange={evt => this.setState({ additionalInfo: evt.target.value })}
                placeholder="Additional Information"
              />
            </div>
            {this.state.searchId > 0 && <WithDocumentStation searchId={this.state.searchId} />}

            <div
              css={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 43,
                marginBottom: 50,
              }}
            >
              <SaveAndHoldButton
                propertyId={+this.props.match.params.propertyid}
                searchTypeId={searchTypeId}
                formData={this.getFormContent}
                afterSubmitRoute={() =>
                  this.props.history.push(`/orders/order-information/${this.props.property.orderId}`)
                }
                userId={this.props.user.id}
                orderId={this.props.property.orderId}
                disabled={loaderStatus}
              />
              <div css={{ marginLeft: 8 }}>
                <SubmitFormButton
                  searchTypeId={searchTypeId}
                  onSubmit={this.handleDownload}
                  reactFormal={false}
                  userId={this.props.user.id}
                  orderId={this.props.property.orderId}
                  loadingStatus={loaderStatus}
                  buttonText={showNext ? 'Next' : `${isEdit ? 'Save' : 'Submit'}`}
                  propertyId={+this.props.match.params.propertyid}
                  getFormContent={this.getFormContent}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          css={{
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 2,
            padding: 16,
            position: 'sticky',
            top: 25,
            marginLeft: 24,
          }}
        >
          <iframe style={{ width: '100%', height: 1000 }} srcDoc={pdfHtml} id="iframe" />
        </div>
      </div>
    );
  }
}

export default withProperty(withUser(HealthDepartmentViolation), searchTypeId, true);
